// function hello() {
//     alert('Welcome to custome js!!!');
// }

// $(function (){
//   alert('Hello!!!');
// })

// Data Picker Initialization
//$('.datepicker').pickadate();
